import { useGetStrings } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { IframeMessages } from "@app/utils/constants"
import { getUrl } from "@app/utils/htmlUtils"
import { faGift } from "@fortawesome/free-solid-svg-icons/faGift"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import "./MyParadiseVouchers.css"

export const MyParadiseVouchers = () => {
	const {
		data: { myParadiseOverviewVouchers },
	} = useGetStrings(undefined, { defaultData: {} })

	return (
		<div
			className="myParadiseVouchers h-100 color-bg-secondary-700 p-3 color-fg-white flex flex-column flex-center"
			onClick={() => {
				if (window.self !== window.top) {
					let url = appStore.get("core.languageCode") + "/shop/gutscheine/eintrittsgutscheine/"
					const base = getUrl()
					window.parent.postMessage(IframeMessages.openUrl + ";" + (base + url), "*")
				} else {
					alert("can not open vouchers if the window is not in an iframe")
				}
			}}
		>
			<div className="flex flex-center f2">
				<FontAwesomeIcon icon={faGift} />
			</div>
			<div className="mt-3 text-center">{myParadiseOverviewVouchers}</div>
		</div>
	)
}
